import { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { acceptInvite } from '../lib/auth';

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token') || '';

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    setMessage('');

    if (!token) {
      setMessage('Missing invite token.');
      return;
    }
    if (password.length < 8) {
      setMessage('Password must be at least 8 characters.');
      return;
    }
    if (password !== confirm) {
      setMessage('Passwords do not match.');
      return;
    }

    setIsLoading(true);
    try {
      await acceptInvite(token, password);
      setMessage('Invite accepted. You can now sign in.');
      setTimeout(() => navigate('/login'), 800);
    } catch (err) {
      setMessage('This invite link is invalid or has expired. If you already have an account, reset your password using the link below.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-[600px] flex items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
      <div className="w-full max-w-md">
        <h2 className="text-NBNA-primary mb-6">Accept Invite</h2>

        {message && (
          <div className="mb-4 p-3 rounded-md text-sm bg-gray-50 text-gray-800">
            {message}
          </div>
        )}

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label htmlFor="password" className="block text-sm font-lato text-NBNA-primary">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-field mt-1 block w-full"
              placeholder="••••••••"
              required
            />
          </div>
          <div>
            <label htmlFor="confirmPassword" className="block text-sm font-lato text-NBNA-primary">Confirm password</label>
            <input
              id="confirmPassword"
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="input-field mt-1 block w-full"
              placeholder="••••••••"
              required
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full btn-primary"
          >
            {isLoading ? 'Submitting…' : 'Set password'}
          </button>
        </form>

        <div className="mt-6 text-center text-sm">
          <Link
            to="/login?forgot=1"
            className="text-NBNA-primary hover:text-NBNA-primary/70 transition-colors"
          >
            Link expired, or already a member? Reset your password instead
          </Link>
        </div>
      </div>
    </div>
  );
}
